import React from "react";
import { Skeleton } from "@material-ui/lab";
export const WithinCityMoveSkeleton = () => {
  const columns = [
    "property_size",
    "city",
    "from",
    "to",
    "move_date",
    "submit",
  ];

  const JSX = columns.map((value,index) => {
    return (
      <div className="m-2" key={"skeleton-nisis-" + index}>
        <Skeleton animation="wave" variant="rect" height={50} />
      </div>
    );
  });

  return (
    <>
      <div className="move-info within-city-move">{JSX}</div>
    </>
  );
};

export const BetweenCityMoveSkeleton = () => {
  const columns = ["property_size", "from", "to", "move_date", "submit"];
  const JSX = columns.map((value,index) => {
    return (
      <div class="m-2" key={"skeleton-nisis-" + index}>
        <Skeleton animation="wave" variant="rect" height={50} />
      </div>
    );
  });

  return (
    <>
      <div className="move-info between-city-move">{JSX}</div>
    </>
  );
};
